// extracted by mini-css-extract-plugin
export default {"percentageButton":"PercentageButton_percentageButton__fBvvZ","percentageButtonText":"PercentageButton_percentageButtonText__6QrRN"};